import {
  TextField,
  Grid,
  InputAdornment,
  SelectChangeEvent,
} from '@mui/material';
import { ChangeEvent } from 'react';
import FrequencySelect from '../../components/FrequencySelect';
import { InvalidEntryFlags, SpectralMaskForm } from './types';

interface Props {
  mask: SpectralMaskForm;
  handleMaskChanged: (
    event:
      | SelectChangeEvent<string>
      | ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => void;
  invalidEntryFlags: InvalidEntryFlags;
}

const SpectralMaskSettingsForm = ({
  mask,
  handleMaskChanged,
  invalidEntryFlags,
}: Props) => {
  return (
    <Grid container spacing={1} style={{ paddingTop: '5px' }}>
      <Grid item xs={12}>
        <TextField
          id='name'
          name='name'
          label='Name'
          value={mask?.name}
          variant='outlined'
          size='small'
          onChange={handleMaskChanged}
        />
      </Grid>
      <Grid item xs={6}>
        <TextField
          id='beginFrequencyValue'
          name='beginFrequencyValue'
          label='Begin'
          value={mask?.beginFrequencyValue}
          variant='outlined'
          size='small'
          onChange={handleMaskChanged}
          error={invalidEntryFlags.begin}
        />
      </Grid>
      <Grid item xs={6}>
        <FrequencySelect
          selected={mask?.beginFrequencyUnit}
          name='beginFrequencyUnit'
          onChange={handleMaskChanged}
        />
      </Grid>
      <Grid item xs={6}>
        <TextField
          id='endFrequencyValue'
          name='endFrequencyValue'
          label='End'
          value={mask?.endFrequencyValue}
          variant='outlined'
          size='small'
          onChange={handleMaskChanged}
          error={invalidEntryFlags.end}
        />
      </Grid>
      <Grid item xs={6}>
        <FrequencySelect
          selected={mask?.endFrequencyUnit}
          name='endFrequencyUnit'
          onChange={handleMaskChanged}
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          type='number'
          id='upperbound'
          name='upperbound'
          label='Upperbound'
          value={mask?.upperbound}
          variant='outlined'
          size='small'
          onChange={handleMaskChanged}
          error={invalidEntryFlags.upperbound}
          InputProps={{
            endAdornment: <InputAdornment position='end'>dBm</InputAdornment>,
          }}
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          type='number'
          id='lowerbound'
          name='lowerbound'
          label='Lowerbound'
          value={mask?.lowerbound}
          variant='outlined'
          size='small'
          onChange={handleMaskChanged}
          error={invalidEntryFlags.lowerbound}
          InputProps={{
            endAdornment: <InputAdornment position='end'>dBm</InputAdornment>,
          }}
        />
      </Grid>
    </Grid>
  );
};

export default SpectralMaskSettingsForm;
